/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geostylelabel2Inputs */

const en_geostylelabel2 = /** @type {(inputs: Geostylelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map style`)
};

const de_geostylelabel2 = /** @type {(inputs: Geostylelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartenstil`)
};

/**
* | output |
* | --- |
* | "Map style" |
*
* @param {Geostylelabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geostylelabel2 = /** @type {((inputs?: Geostylelabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geostylelabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geostylelabel2(inputs)
	return de_geostylelabel2(inputs)
});
export { geostylelabel2 as "geoStyleLabel" }